import { render } from "./SupportView.vue?vue&type=template&id=0a5fd67b&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=0a5fd67b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5fd67b"]])

export default __exports__